"use client";

import { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import WorkApproach from "../work/workApproach";
import BottomCurves from "../curves/bottomCurves";

gsap.registerPlugin(ScrollTrigger);

export default function HorizontalScrollContainer({ data }: any) {
  const sectionRef = useRef(null);
  const horizontalScrollRef: any = useRef(null);
  const iconRef1 = useRef(null);
  const iconRef2 = useRef(null);

  useGSAP(() => {
    const handleLoad = () => {
      gsap.to([iconRef1.current, iconRef2.current], {
        rotation: 360,
        duration: 12,
        repeat: -1,
        ease: "none",
      });

      if (window.innerWidth > 768) {
        const contentWidth =
          horizontalScrollRef.current.scrollWidth -
          window.innerWidth +
          250;

        const ctx = gsap.context(() => {
          gsap.timeline({
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top top",
              end: `+=${contentWidth}`,
              pin: true,
              scrub: 1,
              markers: false,
              invalidateOnRefresh: true,
            },
          }).to(horizontalScrollRef.current, { x: -contentWidth });
        });
        ScrollTrigger.refresh(); // Explicit refresh here
        return () => ctx.revert();
      }
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      ScrollTrigger.refresh();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      ScrollTrigger.refresh();
    });

    observer.observe(horizontalScrollRef.current, {
      childList: true,
      subtree: true,
    });
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="bg-midGradientPurple md:h-screen min-h-[560px] pb-[20.333vw] pt-[9.333vw] md:pr-0"
      ref={sectionRef}
    >
      <div
        className="relative md:flex flex-row space-y-8 md:space-y-0 md:space-x-12 horizontal-scroll"
        ref={horizontalScrollRef}
      >
        {data.workApproaches.map((work: any, index: number) => (
          <div
            key={index}
            className={
              index === data.workApproaches.length - 1
                ? "md:pl-24"
                : ""
            }
          >
            <WorkApproach
              title={work.title}
              description={work.description}
              description2={work.description2}
              media={work.media}
              mediaType={work.mediaType}
              direction={work.direction}
              icon={data.icon}
              index={index}
              iconRef1={iconRef1}
              iconRef2={iconRef2}
            />
          </div>
        ))}
      </div>
      <BottomCurves
        direction="right"
        color={data.waveBgColor.waveBgColor}
      />
    </section>
  );
}
